import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="modal--anchor-link"
export default class extends Controller {

  // このコントローラを呼び出す要素にクリックイベントを設定する
  // クリック時にモーダルを閉じ、同ページ内の任意の要素へのスクロールを実行
  connect() {
    this.element.addEventListener('click', this.reloadPage.bind(this));
  }

  reloadPage(event) {
    event.preventDefault();
    const scrollTarget = document.getElementById(this.element.dataset.anchorId);
    const modalElement = document.getElementById(this.element.dataset.modalId);


    modalElement.addEventListener('hidden.bs.modal', () => {
      if (scrollTarget) {
        window.scrollTo({
          top: scrollTarget.offsetTop - 70,
          behavior: 'smooth'
        });
      }
    });

    // モーダルを閉じる
    Modal.getOrCreateInstance(modalElement).hide();
  }
}